module.exports = __webpack_public_path__ + "img/logo-sportplatzmedia-2022.58cbb0da.svg";